import {HStack, Text, Tooltip} from '@chakra-ui/react';
import {useHalState} from '@synako/haligator';
import {Navigable} from '@synako/halitrek';
import {Trans, useTranslation} from 'react-i18next';
import {DisponibiliteArticle} from 'api-types/ffconnect';
import {dateAvecSlashes} from 'ff-common';
import {useClient} from '@/haligator-factory';
import {CartonIcon} from '@/components/svg/CartonIcon';

/**
 * Encart DLC affiché sous l'article.
 * Affiche directement la DLC estimée si disponible.
 * Visible uniquement si le client a `affichage_dlc === 'active'`.
 * En cas d'erreur serveur (Tolède indisponible, etc.) : message neutre à la place du badge.
 */
export const EncartDLC: React.FC<{dispo?: Navigable<DisponibiliteArticle>}> = ({
  dispo: followDispo,
}) => {
  const {t} = useTranslation();
  const clientNav = useClient();
  const clientHook = useHalState(clientNav);
  const dispoHook = useHalState(followDispo, {getOptions: {cache: 'no-store'}});

  if (!followDispo) return null;
  if (clientHook.data?.affichage_dlc !== 'active') return null;

  // Erreur ou Pas de données ou DLC absente : on n'affiche rien (comportement initial silencieux)
  if (dispoHook.error || dispoHook.data?.tolede.dlc_envisagee === undefined)
    return null;

  // DLC du jour pour une préparation du jour
  return (
    <Tooltip label={t('ligne_produit.encart_dlc_tooltip')}>
      <HStack
        background='gray.lighter'
        borderRadius='6px'
        px='2'
        py='1'
        spacing={1}
        alignItems='center'
        w='fit-content'
      >
        <CartonIcon
          color='gray.dark'
          width='15px'
          height='15px'
        />
        <Text
          fontSize='xs'
          color='gray.dark'
          fontWeight='600'
        >
          <Trans>
            {t('ligne_produit.encart_dlc', {
              date: dateAvecSlashes(dispoHook.data.tolede.dlc_envisagee),
            })}
          </Trans>
        </Text>
      </HStack>
    </Tooltip>
  );
};
